import {useEffect, useContext, useState} from 'react';
import {createFetchRequest} from "../util/fetcher";
import {encodedOrDefault, retrieveErrorMessage} from "../util/utilites";
import {AuthContext} from "../auth/AuthContext";
import {CategoryContext} from "./CategoryContext";
import {Article, ArticleWithCaratName, Carat, Category} from "../models";

interface LoadState {
    articles: boolean;
    carats: boolean;
    categories: boolean;
}

export const useArticleFinder = () => {
    const { sessionId } = useContext(AuthContext);
    const [carats, setCarats] = useState<Carat[]>([]);
    const [error, setError] = useState('');
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState<LoadState>({
        articles: false,
        carats: false,
        categories: false
    });
    const { currentCategory, currentPage, pageSize, query } = useContext(CategoryContext);
    const [articleByCategory, setArticleByCategory] = useState<Map<string, ArticleWithCaratName[]>>(new Map<string, ArticleWithCaratName[]>());
    const key = `${currentCategory}:${query}:${currentPage}:${pageSize}`;

    const handleError = (e: unknown) => {
        setError(retrieveErrorMessage(e));
    }

    useEffect(() => {
        if (carats.length || loading.carats) {
            return;
        }
        setLoading({ ...loading, carats: true });
        void createFetchRequest('api/carat/all', sessionId)
            .then( res => res.json() )
            .then( carats => { setCarats( carats ); })
            .catch( handleError )
            .finally( () => { setLoading({ ...loading, carats: false }); });
    }, [loading, carats, sessionId]);

    useEffect(() => {
        if (categories.length || loading.categories) {
            return;
        }
        setLoading({...loading, categories: true});
        void createFetchRequest('api/category/all', sessionId)
            .then( res => res.json() )
            .then( categories => { setCategories( categories ); })
            .catch( handleError )
            .finally( () => { setLoading({...loading, categories: false}); });
    }, [loading, categories, sessionId]);

    useEffect(() => {
        if (!categories.length || !carats.length || loading.articles || loading.categories || loading.carats) {
            return;
        }
        if (articleByCategory.has(key)) {
            return;
        }
        debugger;
        setLoading({ ...loading, articles: true });
        void createFetchRequest(`api/article/byCategory/${encodedOrDefault(categories.find( c => c.Id === currentCategory)?.Code)}/${encodedOrDefault( query )}/${currentPage}/${pageSize}`, sessionId )
            .then( res => res.json() )
            .then( articles => {
                setArticleByCategory(new Map(articleByCategory.set(key, articles.map( (a: Article) => ({ ...a, CaratName: carats.find(c => c.Id === a.Carat)?.Code})) )));
            })
            .catch( handleError )
            .finally( () => { setLoading({...loading, articles: false }); });
    }, [currentPage, currentCategory, categories, carats, pageSize, loading, articleByCategory, sessionId, key, query]);

    return {
        loading: loading.articles || loading.carats || loading.categories,
        error,
        articles: articleByCategory.get(key)
    }
};